(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/components/checkbox-syndicate-item.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/components/checkbox-syndicate-item.js');
'use strict';

const Checkbox = svs.ui.reactForm.Checkbox;

const CheckboxSyndicateItem = _ref => {
  let title = _ref.title,
    id = _ref.id,
    model = _ref.model,
    onChange = _ref.onChange;
  const notification = model.find(item => item.mailTypeId === id);
  const checked = notification.transports.find(item => item.transportType === 'mailNotification');
  return React.createElement(Checkbox, {
    checked: (checked === null || checked === void 0 ? void 0 : checked.enabled) || false,
    onChange: () => onChange(id)
  }, title);
};
svs.myProfile.react.pages.notifications.components.CheckboxSyndicateItem = CheckboxSyndicateItem;

 })(window);